import AudienceCategory from './AudienceCategory';

export default AudienceCategory;
